module.exports = __webpack_public_path__ + "img/card1.5bdc7c0b.png";